// import { useMemo } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import {
//   useGetCourseBySlugQuery,
//   useGetCourseResultQuery,
// } from "@/features/api/courseApi";

// import {
//   User,
//   Award,
//   CheckCircle2,
//   History,
//   Loader2,
//   BarChart3,
//   Trophy,
// } from "lucide-react";

// export default function CourseResult() {
// const { slug } = useParams();
// const navigate = useNavigate();

//   /* ================= COURSE ================= */
//   const { data: courseRes, isLoading: courseLoading } =
//     useGetCourseBySlugQuery(slug, { skip: !slug });

//   const course = courseRes?.course;

//   /* ================= RESULT ================= */
//   const {
//     data: rawResult,
//     isLoading: resultLoading,
//     error,
//   } = useGetCourseResultQuery(course?._id, {
//     skip: !course?._id,
//     refetchOnMountOrArgChange: true,
//   });

//   /* ================= NORMALIZE BACKEND ================= */
//   const { results, user } = useMemo(() => {
//     if (!rawResult) return { results: [], user: {} };

//     // handle multiple backend shapes safely
//     if (rawResult.results) {
//       return {
//         results: rawResult.results,
//         user: rawResult.user || {},
//       };
//     }

//     if (rawResult.data?.results) {
//       return {
//         results: rawResult.data.results,
//         user: rawResult.data.user || {},
//       };
//     }

//     return { results: [], user: {} };
//   }, [rawResult]);

//   /* ================= LOADING ================= */
//   if (courseLoading || resultLoading) {
//     return (
//       <div className="flex items-center justify-center min-h-screen">
//         <Loader2 className="animate-spin mr-2" /> Loading results...
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="min-h-screen flex items-center justify-center text-red-600">
//         Failed to load results
//       </div>
//     );
//   }

//   if (!results.length) {
//     return (
//       <div className="min-h-screen flex items-center justify-center">
//         No attempts yet.
//       </div>
//     );
//   }

//   /* ================= CALCULATIONS ================= */
// const attempts = results.length;
// const percentages = results.map(r => Number(r.score || 0));

// const bestPercentage = percentages.length ? Math.max(...percentages) : 0;

// const avgPercentage = percentages.length
//   ? Math.round(percentages.reduce((a,b)=>a+b,0)/percentages.length)
//   : 0;

// const latest = results[results.length - 1];
// const latestPct = Number(latest?.score || 0);

// const passed = latestPct >= 30;

//   const handleRetake = () =>
// navigate(`/courses/${course?.slug}/learn`);
//   /* ================= UI ================= */
//   return (
//     <div className="min-h-screen bg-gray-50 py-10 px-4">
//       <div className="max-w-5xl mx-auto space-y-8">

//         <div className="text-center">
//         <h1 className="text-3xl font-bold">{course?.title}</h1>
//           <p className="text-gray-500">Course Result Summary</p>
//         </div>

//         <div className="grid md:grid-cols-4 gap-4">
//           <Stat icon={Trophy} label="Best %" value={`${bestPercentage}%`} />
//           <Stat icon={BarChart3} label="Average %" value={`${avgPercentage}%`} />
//           <Stat icon={History} label="Attempts" value={attempts} />
//           <Stat icon={Award} label="Latest %" value={`${latestPct}%`} />
//         </div>

//         <Section title="Student Information" icon={User}>
//           <Info label="Name" value={user.name || "—"} />
//           <Info label="Email" value={user.email || "—"} />
//         </Section>

//         <Section title="Latest Attempt" icon={Award}>

//           <Info label="Percentage" value={`${latestPct}%`} />

//           <Info
//             label="Status"
//             value={
//               <span
//                 className={
//                   passed
//                     ? "text-green-600 font-semibold"
//                     : "text-red-600 font-semibold"
//                 }
//               >
//                 {passed ? "Passed" : "Failed"}
//               </span>
//             }
//           />

//           <button
//             onClick={handleRetake}
//             className="mt-4 flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded"
//           >
//             <CheckCircle2 size={16} /> Retake Course
//           </button>
//         </Section>

//         <Section title="Attempt History" icon={History}>
//           <table className="w-full text-sm">
//             <thead>
//               <tr className="border-b">
//                 <th>#</th>
//                 <th>Score</th>
//                 <th>%</th>
//                 <th>Status</th>
//               </tr>
//             </thead>

//             <tbody>
//               {results.map((r, i) => {
                
//                 const total =
//                 r.totalQuestions ||
//                 r.total ||
//                 r.questionsCount ||
//                 100;
                
//                 const pct = Number(r.score || 0);

//                   return (
//                     <tr key={i} className="border-b text-center">
//                     <td>{i + 1}</td>
//                     <td>{r.score}/{total}</td>
//                     <td>{pct}%</td>
//                     <td className={pct >= 30 ? "text-green-600" : "text-red-600"}>
//                       {pct >= 30 ? "Passed" : "Failed"}
//                     </td>
//                   </tr>
//                   );
//               })}
//             </tbody>
//           </table>
//         </Section>
//       </div>
//     </div>
//   );
// }

// /* ================= HELPERS ================= */

// function Stat({ icon: Icon, label, value }) {
//   return (
//     <div className="bg-white rounded-lg shadow p-4 text-center">
//       <Icon className="mx-auto text-blue-600 mb-2" />
//       <p className="text-sm text-gray-500">{label}</p>
//       <p className="text-2xl font-bold">{value}</p>
//     </div>
//   );
// }

// function Section({ title, icon: Icon, children }) {
//   return (
//     <div className="bg-white shadow rounded-lg p-6 space-y-4">
//       <h2 className="flex items-center gap-2 text-xl font-semibold">
//         <Icon size={20} className="text-blue-600" />
//         {title}
//       </h2>
//       <div className="grid sm:grid-cols-2 gap-4">{children}</div>
//     </div>
//   );
// }

// function Info({ label, value }) {
//   return (
//     <p>
//       <strong>{label}:</strong> {value}
//     </p>
//   );
// }








import { useMemo, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

import {
  useGetCourseBySlugQuery,
  useGetCourseResultQuery,
} from "@/features/api/courseApi";

import {
  User,
  Award,
  CheckCircle2,
  History,
  Loader2,
  BarChart3,
  Trophy,
  TrendingUp,
  AlertTriangle,
  Clock,
} from "lucide-react";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";


/* ================= COMPONENT ================= */

export default function CourseResult() {
  const { slug } = useParams();
  const navigate = useNavigate();

  /* ================= COURSE ================= */

  const {
    data: courseRes,
    isLoading: courseLoading,
    error: courseError,
  } = useGetCourseBySlugQuery(slug, { skip: !slug });

  const course = courseRes?.course;

  
  /* ================= RESULT ================= */

  const {
    data: rawResult,
    isLoading: resultLoading,
    error: resultError,
  } = useGetCourseResultQuery(course?._id, {
    skip: !course?._id,
    refetchOnMountOrArgChange: true,
  });

  /* ================= NORMALIZE ================= */

const { results, user } = useMemo(() => {
  if (!rawResult) {
    return { results: [], user: {} };
  }

  try {
    /* ================= NEW API ================= */
    if (rawResult.progress) {
      const progress = rawResult.progress;

      const lessons = Array.isArray(progress.lessonsProgress)
        ? progress.lessonsProgress
        : [];

      if (lessons.length > 0) {
        return {
          results: lessons.map((lp, i) => ({
            _id: lp.lessonId || i,
            scorePercent: Number(lp?.score ?? 0),
            lessonId: lp.lessonId,
          })),
          user: progress.user || {},
        };
      }

      if (typeof progress.score === "number") {
        return {
          results: [
            {
              _id: "overall",
              scorePercent: progress.score,
            },
          ],
          user: progress.user || {},
        };
      }

      return {
        results: [],
        user: progress.user || {},
      };
    }

    /* ================= OLD API ================= */
    if (Array.isArray(rawResult.results)) {
      return {
        results: rawResult.results,
        user: rawResult.user || {},
      };
    }

    if (rawResult.data?.results) {
      return {
        results: rawResult.data.results,
        user: rawResult.data.user || {},
      };
    }

  } catch (e) {
    console.error("Normalize error:", e);
  }

  return { results: [], user: {} };

}, [rawResult]);

  /* ================= STATS ================= */

  const stats = useMemo(() => {
  if (!results.length) {
    return {
      attempts: 0,
      best: 0,
      avg: 0,
      latest: 0,
      passed: false,
    };
  }

  const arr = results.map((r) =>
    Number(r.scorePercent ?? r.score ?? 0)
  );

  const attempts = results.length;
  const best = Math.max(...arr);
  const avg = Math.round(arr.reduce((a, b) => a + b, 0) / attempts);
  const latest = arr[arr.length - 1] ?? 0;

  const passingScore =
    course?.lessons?.[0]?.passingScore || 30;

  return {
    attempts,
    best,
    avg,
    latest,
    passed: latest >= passingScore, 
  };
}, [results, course]);


  useEffect(() => {
  if (courseError || resultError) {
    console.error(courseError || resultError);
  }
}, [courseError, resultError]);


  const lessonMap = useMemo(() => {
  if (!course?.lessons) return {};
  return Object.fromEntries(
    course.lessons.map(l => [l._id, l.title])
  );
}, [course]);

  /* ================= GRAPH ================= */
const chartData = useMemo(() => {
  if (!results.length) return [];

  return results.map((r, i) => ({
    attempt: lessonMap[r.lessonId] || `Lesson ${i + 1}`,
    score: Number(r.scorePercent ?? 0),
  }));
}, [results, lessonMap]);

  /* ================= WEAK TOPICS ================= */


const weakTopics = useMemo(() => {
  if (!results?.length) return [];

  return [...new Map(
    results
      .map((r) => ({
        lesson: lessonMap[r.lessonId] || "Unknown Lesson",
        score: Number(r.scorePercent ?? 0),
      }))
      .filter((r) => r.score < 50)
      .sort((a, b) => a.score - b.score)
      .map((r) => [r.lesson, r])
  ).values()]
    .slice(0, 3)
    .map((r) => r.lesson);

}, [results, lessonMap]);

const totalTime = useMemo(() => {
  if (!rawResult?.progress?.lessonsProgress) return 0;

  return rawResult.progress.lessonsProgress.reduce(
    (sum, l) => sum + (l.timeSpent || 0),
    0
  );
}, [rawResult]);

  /* ================= INSIGHTS ================= */

  const insights = useMemo(() => {
    const messages = [];

    if (stats.latest < PASS_PERCENT) {
      messages.push("You need improvement to pass this course.");
    }

    if (stats.avg < 50) {
      messages.push("Your average score is low. Focus on basics.");
    }

   if (stats.attempts > 1 && stats.best - stats.latest > 20) {
      messages.push("Your performance is inconsistent.");
    }

    if (messages.length === 0) {
      messages.push("Great job! Keep progressing 🚀");
    }

    return messages;
  }, [stats]);

  /* ================= STATES ================= */

  if (courseLoading || resultLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="animate-spin mr-2" />
        Loading results...
      </div>
    );
  }

  if (courseError || resultError) {
    return (
      <div className="text-center text-red-600 py-20">
        Failed to load results
      </div>
    );
  }

if (!course) {
  return (
    <div className="text-center py-20 text-gray-500">
      Course not found
    </div>
  );
}

const hasRealData = results.some(
  (r) => r.scorePercent !== null && r.scorePercent !== undefined
);
if (!hasRealData) {

  return (
    <div className="text-center py-20">
      <p className="text-gray-500 mb-4">
       Start your first lesson to see results
      </p>

      <button
        onClick={() => navigate(`/courses/${slug}/learn`)}
        className="bg-blue-600 text-white px-6 py-2 rounded"
      >
        Start Learning
      </button>
    </div>
  );
}

  /* ================= UI ================= */

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4">
      <div className="max-w-6xl mx-auto space-y-8">

        {/* HEADER */}
        <div className="text-center">
          <h1 className="text-3xl font-bold">
           {course.title}
            
          </h1>
          <p className="text-gray-500">Performance Dashboard</p>
        </div>

        {/* STATS */}
        <div className="grid md:grid-cols-4 gap-4">
          <Stat icon={Trophy} label="Best %" value={`${stats.best}%`} />
          <Stat icon={BarChart3} label="Average %" value={`${stats.avg}%`} />
          <Stat icon={History} label="Lessons Completed" value={stats.attempts} />
          <Stat icon={Award} label="Latest %" value={`${stats.latest}%`} />
          <Stat icon={Clock} label="Total Time" value={`${Math.floor(totalTime / 60)}m ${totalTime % 60}s`} />
        </div>

        {/* GRAPH */}
       <Card title="Performance Trend" icon={TrendingUp}>
  {chartData.length ? (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="attempt" />
        <YAxis />
        <Tooltip />
        <Line type="monotone" dataKey="score" strokeWidth={2} />
      </LineChart>
    </ResponsiveContainer>
  ) : (
    <p className="text-gray-500 text-center">No chart data</p>
  )}
</Card>

        {/* WEAK TOPICS */}
        <Card title="Weak Areas" icon={AlertTriangle}>
          {weakTopics.length ? (
            <ul className="list-disc ml-5">
              {weakTopics.map((t, i) => (
              <li key={t}>{t}</li>
              ))}
            </ul>
          ) : (
            <p>No weak topics detected 🎉</p>
          )}
        </Card>

        {/* INSIGHTS */}
        <Card title="Performance Insights" icon={TrendingUp}>
          <ul className="space-y-2">
            {insights.map((msg, i) => (
              <li key={i}>• {msg}</li>
            ))}
          </ul>
        </Card>

        {/* STUDENT */}
        <Card title="Student Info" icon={User}>
          <p><b>Name:</b> {user?.name || "—"}</p>
          <p><b>Email:</b> {user?.email || "—"}</p>
        </Card>

        {/* ACTION */}
        <div className="text-center">
          <button
            onClick={() => navigate(`/courses/${slug}/learn`)}
            className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
          >
            Retake Course
          </button>
        </div>
      </div>
    </div>
  );
}

/* ================= UI COMPONENTS ================= */

function Stat({ icon: Icon, label, value }) {
  return (
    <div className="bg-white p-4 rounded shadow text-center">
      <Icon className="mx-auto mb-2 text-blue-600" />
      <p className="text-sm text-gray-500">{label}</p>
      <p className="text-xl font-bold">{value}</p>
    </div>
  );
}

function Card({ title, icon: Icon, children }) {
  return (
    <div className="bg-white p-6 rounded shadow space-y-4">
      <h2 className="flex items-center gap-2 font-semibold text-lg">
        <Icon className="text-blue-600" size={18} />
        {title}
      </h2>
      {children}
    </div>
  );
}